export default __webpack_public_path__ + "static/media/favicon.a50563f3.png";